import { Eye, FileCheck, Key, Lock, Shield, Users } from "lucide-react";
import type { ElementType } from "react";
import { cn } from "../../../lib/utils";
import { lpConfig } from "../lpConfig";
import { useFadeIn } from "../useFadeIn";

const iconMap: Record<string, ElementType> = {
  Shield,
  Lock,
  Eye,
  Users,
  Key,
  FileCheck,
};

const securityCards = lpConfig.security.cards.map(card => ({
  ...card,
  icon: iconMap[card.icon] || Shield,
}));

/**
 * ランディングページのセキュリティセクション
 * エンタープライズグレードのセキュリティ機能を6つのカードで表示する
 * @return {JSX.Element} セキュリティセクションコンポーネント
 */
export function LpSecurity() {
  const { ref, isVisible } = useFadeIn();

  return (
    <section className="py-24 lg:py-32 bg-gradient-to-b from-gray-50 to-white">
      <div
        ref={ref}
        className={cn(
          "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 lp-fade-in-up",
          isVisible && "lp-visible",
        )}
      >
        <div className="text-center mb-16">
          <span className="text-xs font-bold tracking-widest text-[#1667CF] uppercase mb-4 block">
            {lpConfig.security.sectionLabel}
          </span>
          <h2 className="text-4xl font-bold text-[#0F1649]">
            {lpConfig.security.heading}
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {securityCards.map(card => {
            const Icon = card.icon;
            return (
              <div
                key={card.title}
                className="p-6 rounded-2xl border border-gray-100 bg-white hover:shadow-md transition-shadow"
              >
                <div className="w-12 h-12 rounded-xl bg-[#02072F]/5 text-[#02072F] flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6" />
                </div>
                <h3 className="text-lg font-bold text-[#0F1649] mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-gray-500 leading-relaxed">
                  {card.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
